export default {
    required: (value: string) => !!value || 'Required.',
    passwordRequired: (v: string) => !!v || 'Password is required',
    minimalLengthPassword: (v: string) => v.length >= 6 || 'Password must be at least 6 characters',
    emailRequired: (v: string) => !!v || 'Email is required',
    emailValid: (v: string) => /.+@.+\..+/.test(v) || 'Email must be valid'
};
